<div class="row mb-3">
    <div class="col-md-8">
        <h3>{{pageTitle}}</h3>
    </div>
    <div class="col-md-4">
        <span class="float-right ml-auto">
            <button class="btn btn-default" type="button" (click)="goToMappingList();">
                View CVS Mapping List
            </button>
        </span>

    </div>
</div>
<div class="add-cvs-mapping-page">
    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>
    <div [ngStyle]="{'opacity': mode === 'view' ? '0.7':'1'}">
        <form [formGroup]="capabilityForm" (ngSubmit)="capabilityForm.valid && onSave(capabilityForm.value)" novalidate>
            <div class="row">
                <div class="col-5">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>CVS Mapping :</mat-label>
                            <input matInput placeholder="CVS Attribute" formControlName="capability" required>
                            <mat-error *ngIf="hasError('capability', 'required')">CVS Mapping is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-md-1"></div>

            </div>
            <div class="row">
                <div class="col-5">
                    <div class="form-group">
                        <mat-form-field class="col-12 p-0 mt-2" appearance="outline" [ngClass]="{'mat-form-field-invalid':isSubmit && invalidFeatureSelection}">
                            <mat-label>External Support Topic Name</mat-label>
                            <mat-select name="selectedExternalFeatureName" formControlName="externalSTName" (selectionChange)="onExternalSupportTopicNameChange()"
                                multiple>
                                <mat-option *ngFor="let feature of externalSPList" [value]="feature">
                                    {{feature.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="mat-error error-message-block" *ngIf="isSubmit && invalidFeatureSelection">Atleast select any one of the Support Topic from Internal or External</div>

                    </div>
                </div>
                <div class="col-1"></div>
                <div class="col-5">
                    <div class="form-group">
                        <mat-form-field class="col-12 p-0 mt-2" appearance="outline" [ngClass]="{'mat-form-field-invalid': isSubmit && invalidFeatureSelection}">
                            <mat-label>Internal Support Topic Name</mat-label>
                            <mat-select name="selectedInternalFeatureName" formControlName="internalSTName" (selectionChange)="onInternalSupportTopicNameChange()"
                                multiple>
                                <mat-option *ngFor="let feature of internalSPList" [value]="feature">
                                    {{feature.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="mat-error error-message-block" *ngIf="isSubmit && invalidFeatureSelection">Atleast select any one of the Support Topic from Internal or External</div>
                    </div>
                </div>
            </div>
        </form>

        <div class="row">
            <div class="col-md-5">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>External</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div *ngFor="let item of externalFeatureList;let i=index;">
                            <div *ngIf="item.type == 'external'" class="control-list feature-row feature-border">
                                <span style="height:35px;" class="ellipsis" [matTooltip]="item.name" matTooltipPosition="below" matTooltipClass="tooltip-class">{{item.name}}</span>
                                <span class="action-controls float-right">
                                    <button [disabled]="mode==='view'" matTooltip="Click to Delete the mapping" type="button" class="ml-2 action-btn" type="button"
                                        (click)="openDeleteConfirmDialog(item)">
                                        <img alt="Delete" class="action-icon" [src]="commonService.commonFiles['delete']">
                                    </button>
                                </span>
                            </div>

                        </div>

                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-5">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>Internal</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div *ngFor="let item of internalFeatureList;let i=index">
                            <div *ngIf="item.type == 'internal'" class="control-list feature-row feature-border">
                                <span style="height:35px;" class="ellipsis" [matTooltip]="item.name" matTooltipPosition="below" matTooltipClass="tooltip-class">{{item.name}}</span>
                                <span class="action-controls float-right">
                                    <button [disabled]="mode==='view'" matTooltip="Click to Delete the mapping" type="button" class="ml-2 action-btn " type="button"
                                        (click)="openDeleteConfirmDialog(item)">
                                        <img alt="Delete" class="action-icon" [src]="commonService.commonFiles['delete']">
                                    </button>
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div class="row"></div>
    </div>

    <div class="row mt-5">
        <div class="col-md-12 action-controls">
            <span *ngIf="mode==='view'">
                <button class="btn btn-default" (click)="onEdit()">Edit</button>
            </span>
            <span *ngIf="mode!=='view'">
                <button class="btn btn-default" (click)="onSave(capabilityForm.value)">Save</button>
            </span>
            <span *ngIf="mode!=='view'" class="ml-2">
                <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
            </span>
        </div>
    </div>

</div>